import { useEffect, useState } from "react";
import { Check, Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";

/** Search the shared catalog for a model within a category. */
export default function CatalogPicker({ category, selectedId, onSelect, onCustom, custom }) {
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!category) return;
    const t = setTimeout(async () => {
      const { data } = await api.get(`/products?category=${category}&limit=50${q ? `&q=${encodeURIComponent(q)}` : ""}`);
      setItems(data.items);
    }, 200);
    return () => clearTimeout(t);
  }, [q, category]);

  return (
    <div className="space-y-3" data-testid="catalog-picker">
      <div className="relative">
        <Search className="absolute left-3 top-2.5 h-4 w-4 text-zinc-500" />
        <Input data-testid="catalog-search-input" className="pl-9" placeholder="Marka veya model ara (örn. T-Motor F7)" value={q} onChange={(e) => setQ(e.target.value)} />
      </div>
      <div className="max-h-72 overflow-y-auto rounded-md border border-black/[0.08] divide-y divide-black/[0.06]">
        {items.map((p) => (
          <button type="button" key={p.id} data-testid={`catalog-option-${p.id}`} onClick={() => onSelect(p)}
            className={`flex w-full items-center justify-between px-4 py-2.5 text-left text-sm hover:bg-black/[0.03] ${selectedId === p.id ? "bg-[#0071e3]/10" : ""}`}>
            <span><span className="text-zinc-500">{p.brand}</span> {p.model} {p.revision && <span className="ml-1 rounded bg-black/[0.05] px-1 font-mono text-xs">{p.revision}</span>}</span>
            {selectedId === p.id && <Check className="h-4 w-4 text-[#0071e3]" />}
          </button>
        ))}
        {items.length === 0 && <p className="px-4 py-3 text-sm text-zinc-500">Eşleşen katalog modeli yok.</p>}
      </div>
      <button type="button" onClick={onCustom} data-testid="catalog-custom-button"
        className={`w-full rounded-full border px-4 py-2.5 text-sm ${custom ? "border-[#0071e3] text-orange-700" : "border-dashed border-black/[0.08] text-zinc-500"}`}>
        Ürünüm katalogda yok — marka ve modeli kendim gireceğim
      </button>
    </div>
  );
}
